export const TOPIC = 'topic';
export const VIDEO = 'video';
export const QUIZ = 'quiz';
export const DETAILS = 'details';
export const PODCAST = 'podcast';



// WEBPACK FOOTER //
// ./src/constants/topicTabs.js